import type { DayKind, LeavePerson } from '@trippath/shared';

/** Whether a person works on a day by their week, Monday first: `1111100`. */
export function works(workdays: string, day: string): boolean {
  const weekday = (new Date(`${day}T00:00:00Z`).getUTCDay() + 6) % 7;
  return workdays.charAt(weekday) === '1';
}

/** What a person marked a day as; `null` when nothing. */
export function kindOn(person: LeavePerson, day: string): DayKind | null {
  return person.days.find((one) => one.day === day)?.kind ?? null;
}

/** The day after one. */
function next(day: string): string {
  return new Date(Date.parse(`${day}T00:00:00Z`) + 86_400_000).toISOString().slice(0, 10);
}

/** A person's marked days as runs of one kind on days one after another: 12–13 Nov on leave. */
export function runsOf(
  days: LeavePerson['days'],
): { kind: DayKind; from: string; to: string }[] {
  const runs: { kind: DayKind; from: string; to: string }[] = [];
  for (const { day, kind } of days) {
    const last = runs.at(-1);
    if (last && last.kind === kind && next(last.to) === day) last.to = day;
    else runs.push({ kind, from: day, to: day });
  }
  return runs;
}
